import { BaseTheme, Theme } from 'shared/types';
import { volvo } from './volvo';

const waylands: Theme<BaseTheme> = volvo;

export { waylands };
